import { marked } from 'marked'

export function renderMarkdown (value: string) {
  return marked.parse(value, { async: false }) as string
}
